import React from "react";
import { ChatMessageItem } from "src/store/reducers/chat/chatReducer";

interface Props {
  message: ChatMessageItem;
  isSelf: boolean;
}

function formatTime(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function isImageType(mime: string | null): boolean {
  return !!mime && mime.startsWith("image/");
}

const MessageBubble: React.FC<Props> = ({ message, isSelf }) => {
  const handleDownload = async (url: string, filename: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch {
      window.open(url, "_blank");
    }
  };

  return (
    <div className={`drjobs-msg-bubble-row ${isSelf ? "drjobs-msg-bubble-row--self" : "drjobs-msg-bubble-row--other"}`}>
      <div className={`drjobs-msg-bubble ${isSelf ? "drjobs-msg-bubble--self" : "drjobs-msg-bubble--other"}`}>
        {message.message_text && (
          <p className="drjobs-msg-bubble__text">{message.message_text}</p>
        )}

        {message.attachment_url && (
          <div className="drjobs-msg-bubble__attachment">
            {isImageType(message.attachment_type) ? (
              <div className="drjobs-msg-bubble__img-wrap">
                <a href={message.attachment_url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={message.attachment_url}
                    alt={message.attachment_name || "attachment"}
                    className="drjobs-msg-bubble__img"
                  />
                </a>
                <button
                  className="drjobs-msg-bubble__download-btn"
                  onClick={() => handleDownload(message.attachment_url!, message.attachment_name || "image")}
                  title="Download"
                >
                  <i className="fa fa-download" />
                </button>
              </div>
            ) : (
              <div className="drjobs-msg-bubble__file-row">
                <a
                  href={message.attachment_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="drjobs-msg-bubble__file-link"
                >
                  <i className="fa fa-paperclip" />
                  <span>{message.attachment_name || "attachment"}</span>
                </a>
                <button
                  className="drjobs-msg-bubble__download-btn"
                  onClick={() => handleDownload(message.attachment_url!, message.attachment_name || "file")}
                  title="Download"
                >
                  <i className="fa fa-download" />
                </button>
              </div>
            )}
          </div>
        )}

        <span className="drjobs-msg-bubble__time">{formatTime(message.created_at)}</span>
      </div>
    </div>
  );
};

export default MessageBubble;
